// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2yopK","emails":"CreateEditClinics_emails__keTHG","emailTagLabel":"CreateEditClinics_emailTagLabel__1BW1Q"};